import { render, staticRenderFns } from "./CalcFormCardPointLoad.vue?vue&type=template&id=e61646fe&scoped=true&"
import script from "./CalcFormCardPointLoad.vue?vue&type=script&lang=js&"
export * from "./CalcFormCardPointLoad.vue?vue&type=script&lang=js&"
import style0 from "./CalcFormCardPointLoad.vue?vue&type=style&index=0&id=e61646fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e61646fe",
  null
  
)

export default component.exports